import "./LabInformationAndContactDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import {CommonService} from "../../../../../shared/services";

interface LabInformationAndContactDetailsViewComponentProps {
    labDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const LabInformationAndContactDetailsViewComponent = (props: LabInformationAndContactDetailsViewComponentProps) => {
    const {labDetails, onEditModeOpen,canEdit} = props;

    return (
        <div className="lab-information-component details-tab-data-content">
            {labDetails && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Lab Details</div>
                    {canEdit &&
                    <div className="">
                        <ButtonComponent
                            className={"white-space-nowrap"}
                            type="button"
                            color={"primary"}
                            variant={"outlined"}
                            startIcon={<EditIcon/>}
                            fullWidth={true}
                            handleClick={onEditModeOpen}
                        >
                            Edit Details
                        </ButtonComponent>
                    </div>
                    }
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Lab Name"}> {labDetails?.name || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"NPI Number"}> {labDetails?.npiNumber || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"CAP ID"}> {labDetails?.capId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Lab Type"}> {CommonService.mapLabTypeToName(labDetails?.labType) || 'N/A'}
                            </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Lab ID"}> {labDetails?.labExternalId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"CLIA ID"}> {labDetails?.cliaId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"COLA ID"}> {labDetails?.colaId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Lab Role"}> {CommonService.mapLabRoleToName(labDetails?.labRole) || 'N/A'}
                            </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>
                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Contact Details</div>
                    <div className="details-tab-data-body">

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Email ID"}> {labDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Secondary Mobile Number"}> {CommonService.getMaskedMobileNumber(labDetails?.secondaryMobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(labDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Fax Number"}> {CommonService.getMaskedMobileNumber(labDetails?.faxNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                </>
                <div className="horizontal-line"/>
                <>
                    <div className="view-and-edit-title">Address Details</div>
                    <div className="details-tab-data-body">

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 1"}> {labDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"ZIP Code"}> {labDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"City"}> {labDetails?.city || 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Address Line 2"}> {labDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"State"}> {labDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>

                            </Grid>
                        </Grid>
                    </div>
                </>
            </>}
        </div>
    );

};

export default LabInformationAndContactDetailsViewComponent;
